<sfx-toolbar enableDivider>
    <span translate>Notifications</span>
</sfx-toolbar>

<sfx-content>
    <sfx-section data-layout="column" *ngIf="!loading">
        <ng-container *ngFor="let setting of notifications | keyvalue: keepOrder">
            <mat-slide-toggle class="setting-toggle" color="primary"
                              [attr.aria-label]="setting.value.ariaLabel | async"
                              [(ngModel)]="setting.value.value"
                              (change)="updateSettings(setting.key)"
            >
                {{ setting.value.label | async }}
            </mat-slide-toggle>
        </ng-container>
    </sfx-section>
</sfx-content>
